<template>
  <div class="right-drawer-container">
    <v-card class="settings-container" @click.stop>
      <v-list class="list-item">
        <!-- Call a customer option hidden as of now -->
        <!-- <v-list-item @click="callCustomer" v-show="isCallingAllowed">
          <v-icon color="#21427D" class="mr-3">mdi-phone</v-icon>
          <v-list-item-content>
            <v-list-item-title class="text-[#21427D] font-semibold">
              Call a customer
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider> -->

        <!-- <v-list-item @click="downloadApp">
          <v-icon color="#21427D" class="mr-3">mdi-android</v-icon>

          <v-list-item-content>
            <v-list-item-title class="text-[#21427D] font-semibold">
              Download App
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-divider></v-divider>

        <v-list-item @click="openHelp">
          <!-- <v-list-item-icon> -->
          <v-icon color="#21427D" class="mr-3">mdi-comment-processing-outline</v-icon>
          <!-- </v-list-item-icon> -->
          <v-list-item-content>
            <v-list-item-title class="text-[#21427D] font-semibold"> Help Desk </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'RightDrawer',
  props: {
    isCallingAllowed: Boolean
  },
  methods: {
    callCustomer() {
      this.$emit('openCallCutomer')
    },
    openHelp() {
      this.$emit('openHelpDesk')
    },
    downloadApp() {
      this.$emit('downloadEmpApp')
    }
  }
}
</script>

<style scoped>
.right-drawer-container {
  position: fixed;
  bottom: 56px;
  right: 16px;
  z-index: 1000;
}

.settings-container {
  width: 200px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

/* .settings-container::before {
  content: '';
  position: absolute;
  top: 15px;
  left: -10px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #949393;
  z-index: 1001;
} */

.list-item {
  padding: 0;
}

.list-item {
  list-style: none;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>
